import { Injectable } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  DEFAULT_TREIN_FILTERS,
  TREIN_FILTERS,
} from "src/assets/constants/constants";

@Injectable({
  providedIn: "root",
})
export class TreinFormService {
  private _form!: UntypedFormGroup;

  get form() {
    if (!this._form) {
      this.initForm();
    }
    return this._form;
  }

  private initForm() {
    const filterForm: Record<string, UntypedFormControl> = {};
    TREIN_FILTERS.forEach((key) => {
      filterForm[key] = new UntypedFormControl(
        ['Proximus', 'Orange', 'Telenet'].includes(this.route.snapshot.queryParams[key])
          ? this.route.snapshot.queryParams[key]
          : DEFAULT_TREIN_FILTERS[key]
      );
    });
    this._form = this.fb.group(filterForm);
  }

  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute) {}
}
